/** Local Gaia dev host; Auth0 remains on a cloud tenant (cross-site). */
export function isLocalAtlasHost(hostname: string): boolean {
  return hostname === 'atlaslocal.io' || hostname.endsWith('.atlaslocal.io');
}
